module.exports = __webpack_public_path__ + "static/media/downloadColor.ea34f24d.svg";